<template>
    <div class="preloader">
        <span class="preloader__item preloader__item1"></span>
        <span class="preloader__item preloader__item2"></span>
        <span class="preloader__item preloader__item3"></span>
        <span class="preloader__item preloader__item4"></span>
    </div>
</template>
<script>
export default {
    name: 'PreloaderItem',
    props: {
      msg: String
    },
}
</script>